import { createContext, useContext } from "react";

/**
 * Shell scope-switch channel. The root shell owns the select mutations,
 * the blocking overlay, and the URL rewrite from the backend-confirmed
 * selection; routes (onboarding, catalogs) request switches through this
 * context so every switch shares the same blocking, fail-closed path.
 */
export type ScopeSwitchField = "workspace" | "worldview" | "environment";

export const SEARCH_KEY_BY_SWITCH_FIELD = {
  workspace: "workspace_id",
  worldview: "worldview_id",
  environment: "environment_id",
} as const satisfies Record<ScopeSwitchField, string>;

export interface ScopeSwitchValue {
  /** True while a select operation is in flight (overlay blocking). */
  pending: boolean;
  requestScopeSwitch: (field: ScopeSwitchField, requested: string) => void;
}

export const ScopeSwitchContext = createContext<ScopeSwitchValue | null>(null);

export function useScopeSwitch(): ScopeSwitchValue {
  const value = useContext(ScopeSwitchContext);
  if (!value) {
    throw new Error("useScopeSwitch requires the root shell's ScopeSwitchContext provider");
  }
  return value;
}
